<template>

    <div class="notification_text" :class=" 'is-' + context">
        <slot />
    </div>

</template>

<script>
export default {
    name: 'NotifText',
    props: {
        context: {
            type: String,
            default: 'default'
        }
    }
}


</script>

<style lang="scss" scoped>
.notification_text{
    border-radius: 4px!important;
    padding: 12px;
    text-align: justify;
    // border: 1px solid #f0e9e9;
    // box-shadow: 0 2px 10px #f0e9e9;
    &.is-default{
        background: $white-ter;
    }

}
</style>